export const ZENOS_PATHS = {
  HOME: '/',
  NOT_FOUND: '*',
  ACCESS_DENIED: '/access-denied',
  TOO_MANY_REQUESTS: '/too-many-requests',
} as const;
